export default __webpack_public_path__ + "static/media/promos-active.087a8d6c.svg";